/**
 * Widget logging.
 *
 * The widget runs on client sites, in front of every visitor. Its diagnostic
 * chatter (auth transitions, subscription state, payloads that include emails
 * and feedback text) used to go straight to their console. It's now silent
 * unless switched on — by `config.debug`, or from the console on any page with
 * `localStorage.setItem('markup:debug', '1')` — so support can still get it.
 *
 * Genuine failures still use `console.error` directly, without payloads.
 */
let enabled = false;

export function setDebug(on: boolean | undefined): void {
  enabled = !!on;
}

function isEnabled(): boolean {
  if (enabled) return true;
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('markup:debug') === '1';
  } catch (_) {
    return false;
  }
}

export const log = (...args: unknown[]): void => {
  if (isEnabled()) console.log('[markup]', ...args);
};

export const warn = (...args: unknown[]): void => {
  if (isEnabled()) console.warn('[markup]', ...args);
};
